export function groupHotelsByCity(hotels) {
  return hotels.reduce((acc, hotel) => {
    const { city } = hotel

    if (acc[city]) {
      return { ...acc, [city]: [...acc[city], hotel] }
    } else {
      return { ...acc, [city]: [hotel] }
    }
  }, {})
}

export const getGroupDisplayOptions = (hotelGroups, isDemoMode) => {
  const generalOptions = {
    currentHotel: ' Current hotel',
    allHotels: ' All hotels'
  }

  if (!isDemoMode) {
    return {
      ...generalOptions,
      ...hotelGroups
    }
  }

  const demoOptions = Object.keys(hotelGroups).reduce((acc, id, index) => {
    return {
      ...acc,
      [id]: `Hotel Group ${index + 1}`
    }
  }, {})

  return {
    ...generalOptions,
    ...demoOptions
  }
}

export const getHotelDisplayName = (isDemoMode, hotel, index) => {
  if (isDemoMode) {
    return `Hotel ${hotel.displayId || index + 1}`
  }
  return hotel.hotelName
}

export const getBrandDisplayOptions = (parentChainNames, isDemoMode) => {
  const generalOptions = {
    all: ' Any brand'
  }

  if (!isDemoMode) {
    return {
      ...generalOptions,
      ...parentChainNames
    }
  }

  const demoOptions = Object.keys(parentChainNames).reduce((acc, id, index) => {
    return {
      ...acc,
      [id]: `Brand ${index + 1}`
    }
  }, {})

  return {
    ...generalOptions,
    ...demoOptions
  }
}
